import * as marked from 'marked';

export default [() => {

  const translateText = (text, removeP) => {
    let returnText = marked.parse(text);

    if (removeP) {
      returnText = returnText.replace(new RegExp('<\/?p>', 'g'), '');
    }
    return returnText;
  };

  return {
    translate: (text, removeP = undefined) => translateText(text, removeP),
    translatePure: text => marked.parse(text)
  };
}];


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/services/markdown.service.js